<template>
  <div class="page-grb">
    <NavBar active-menu="grb"></NavBar>
    <SearchGrb></SearchGrb>
  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue';
import SearchGrb from '../components/SearchGrb.vue';
export default {
  components: {
    NavBar,
    SearchGrb,
  },
};
</script>
